import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum SelectedShippingRateSetBy {
  USER = "user",
  LEARNING = "learning",
  AUTOMATIONS = "automations",
  DEFAULT_CHEAPEST = "default_cheapest",
  CHECKOUT_RATE_PURCHASED = "checkout_rate_purchased",
}

const SelectedShippingRateSetByInfoSchema_ = z.object({
  selectedShippingRateUserId: zExt.objectId().nullish(),
  selectedShippingRateAutomationId: zExt.objectId().nullish(),
  selectedShippingRateAutomationName: z.string().nullish(),
});
export const SelectedShippingRateSetByInfoSchema: z.ZodType<SelectedShippingRateSetByInfo> =
  SelectedShippingRateSetByInfoSchema_;

export interface SelectedShippingRateSetByInfo
  extends z.infer<typeof SelectedShippingRateSetByInfoSchema_> {}
